import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateCompensationEntity } from '../../domain/entities/CreateUpdateCompensationEntity'

export class CreateUpdateCompensationModel extends CreateUpdateCompensationEntity {
  driverId?: number
  constructor(dataDto: CreateUpdateCompensationEntity) {
    super()
    mapEntityProperties<CreateUpdateCompensationModel>(this, dataDto, {
      exclude: ['driver'],
      map: {
        driverId: dataDto.driver?.id
      }
    })
  }
}
